import { Check, Copy } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "@/lib/toast";

export function CopyUidButton({ uid }: { uid: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 1800);
    return () => clearTimeout(timer);
  }, [copied]);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(uid);
      setCopied(true);
      toast(t("entityLink.uidCopied"));
    } catch {
      toast(t("entityLink.copyFailed"), { tone: "error" });
    }
  };
  return <button type="button" className="btn btn-ghost h-7 w-7 shrink-0 justify-center p-0 text-muted hover:text-fg" title={`${t("entityLink.copyUid")} · ${uid}`} aria-label={t("entityLink.copyUid")} onClick={() => void copy()}>{copied ? <Check className="h-3.5 w-3.5 text-accent" /> : <Copy className="h-3.5 w-3.5" />}</button>;
}
